import { Button } from 'antd'

// Bạn có thể để các icon này trong thư mục assets hoặc public
const IllustrationEmpty = () => (
  <img
    src="/4ef37f23cd8e0ddb000c30fb1c61ed73a6b78d77.png"
    alt="Empty"
    className="w-50 h-50 mb-4"
  />
)
const IllustrationError = () => (
  <img
    src="/acea3f4153dcc246fb80f65870418e22ac3fa43c.png"
    alt="Error"
    className="w-50 h-50 mb-4"
  />
)

export const EmptyState = ({
  title,
  desc,
  action,
  onAction,
  isRetrying,
  seconds,
}: any) => {
  return (
    <div className="flex min-h-[560px] w-full flex-col items-center justify-center rounded-xl border border-gray-200 bg-white px-4 text-center">
      {title.includes('không thành công') ? (
        <IllustrationError />
      ) : (
        <IllustrationEmpty />
      )}

      <p className="text-lg font-bold text-[#1a1a1a] m-0">{title}</p>
      <p className="text-sm text-[#6b7280] mt-1 px-3 max-w-lg">{desc}</p>

      {!isRetrying ? (
        <Button
          onClick={onAction}
          className="mt-6 rounded-lg bg-[#CE7A58] px-8 py-2 text-sm font-medium text-white shadow hover:bg-[#b56545]"
        >
          {action}
        </Button>
      ) : (
        <p className="mt-4 text-sm font-medium text-[#CE7A58] animate-pulse">
          Đang gửi yêu cầu và đợi sơ đồ mới ({seconds}s)...
        </p>
      )}
    </div>
  )
}
